import { render, staticRenderFns } from "./SendClassroomInvite.vue?vue&type=template&id=676ef62a&scoped=true&"
import script from "./SendClassroomInvite.vue?vue&type=script&lang=js&"
export * from "./SendClassroomInvite.vue?vue&type=script&lang=js&"
import style0 from "./SendClassroomInvite.vue?vue&type=style&index=0&id=676ef62a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676ef62a",
  null
  
)

export default component.exports